import { Component, OnInit } from '@angular/core';
//import { ToastrService } from 'ngx-toastr';
import { GLOBAL } from 'src/app/services/global';

@Component({
  selector: 'app-meson-online',
  templateUrl: './meson-online.component.html',
  styleUrls: ['./meson-online.component.css']
})
export class MesonOnlineComponent implements OnInit {
  
  public correos = GLOBAL.correos;
  
  constructor(/*private toastr: ToastrService*/) { }

  ngOnInit() {
  }

  copyToClipboard(element) {

    var aux = document.createElement("input");
    aux.setAttribute("value", element);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    ////////this.toastr.success('Listo!', 'Email copiado al portapapeles');

  }

}
